import { render, staticRenderFns } from "./Goback.vue?vue&type=template&id=4864af4e&scoped=true&"
import script from "./Goback.vue?vue&type=script&lang=js&"
export * from "./Goback.vue?vue&type=script&lang=js&"
import style0 from "./Goback.vue?vue&type=style&index=0&id=4864af4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864af4e",
  null
  
)

export default component.exports